var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.4,
    height: 16,
    viewBox: "0 0 14.4 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-buildings",
    transform: "translate(-4.5 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M17.3,3h-8A1.6,1.6,0,0,0,7.7,4.6V9.4H6.1A1.6,1.6,0,0,0,4.5,11v7.2a.8.8,0,0,0,.8.8H18.1a.8.8,0,0,0,.8-.8V4.6A1.6,1.6,0,0,0,17.3,3ZM6.1,11h4.8v6.4H6.1Zm11.2,6.4H12.5V11a1.6,1.6,0,0,0-1.6-1.6H9.3V4.6h8Z",
    fill: "#bf0a76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M13.7,9h1.6v1.6H13.7Zm3.2,0h1.6v1.6H16.9Zm0,3.225h1.6V13.8H16.9Zm0,3.175h1.6V17H16.9Zm-6.4,0h1.6V17H10.5Z",
    transform: "translate(-2.8 -2.8)",
    fill: "#bf0a76"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings);
export default __webpack_public_path__ + "static/media/buildings.af193dbd140a45934912ad440b7ed3f4.svg";
export { ForwardRef as ReactComponent };